"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/servicesSection.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServicesSectionCirclesItem = {
    key: Key | null | undefined;
    /** Detected variants: "circle" */
    className?: string;
};

type ServicesSectionSwipersItem = {
    key: Key | null | undefined;
    /** Detected variants: "Wellness Therapies & Treatments" | "Mind-Body Healing Programs" | "Preventive Healthcare Services" | "Recovery & Stress Management" */
    h30Text: ReactNode;
    /** Detected variants: "Experience transformation healing through massage therapy, acupuncture, energy work." | "Integrate mental clarity with physical wellness through mindfulness meditation." | "Stay ahead of health challenges with nutritional counseling, lifestyle assessments." | "Rebuild resilience and overcome burnout through specialized recovery protocols." */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/service/wellness-service-01.jpg" | "/Templates/Doccure/img/service/wellness-service-02.jpg" | "/Templates/Doccure/img/service/wellness-service-03.jpg" | "/Templates/Doccure/img/service/wellness-service-04.jpg" */
    src: string;
    /** Detected variants: "services-item-seventeen wow fadeInUp" */
    className?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "services-img" */
    div0ClassName?: string;
    /** Detected variants: "services-content" */
    div0ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "Wellness Therapies" */
    alt?: string;
    serviceTagsItems?: ServicesSectionDivsItem[];
};

type ServicesSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Pain Relief" | "Improved Circulation" | "Deep Relaxation" | "Reduce Anxiety" | "Enhance Focus" | "Inner Peace" | "Disease Prevention" | "Optimal Nutrition" | "Lifestyle" | "Burnout Recovery" | "Stress Relief" | "Improved Sleep" */
    linkText: ReactNode;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeSeventeenServicesSectionGeneratedProps = {
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServicesSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Collaborative Healing Services" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Personalized therapies and programs designed to address your unique wellness needs" */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv1Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    /** Default: "#" */
    sectionDiv2Link0LinkHref?: string;
    sectionDiv2Link0LinkVisible?: boolean;
    sectionDiv2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "View All Services" */
    sectionDiv2Link0Span0SpanText?: ReactNode;
    swiperSlideSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: ServicesSectionSwipersItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    swiperSlideDiv0Div0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSectionSwipersItem) => Partial<ComponentProps<"h3">>);
    swiperSlideDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionSwipersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    servicesSectionCircles: ServicesSectionCirclesItem[];
    servicesSectionSwipers: ServicesSectionSwipersItem[];
    servicesSectionCirclesItemWrapper?: (item: ServicesSectionCirclesItem, content: ReactNode) => ReactNode;
    servicesSectionCirclesRenderer?: (defaultNode: ReactNode) => ReactNode;
    servicesSectionSwipersItemWrapper?: (item: ServicesSectionSwipersItem, content: ReactNode) => ReactNode;
    servicesSectionSwipersRenderer?: (defaultNode: ReactNode) => ReactNode;
    servicesSectionSwipersImageVisible?: boolean;
    servicesSectionSwipersImageRenderer?: (item: ServicesSectionSwipersItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionSwipersH3Visible?: boolean;
    servicesSectionSwipersH3Renderer?: (item: ServicesSectionSwipersItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionSwipersImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionSwipersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    servicesSectionSwipersH3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSectionSwipersItem) => Partial<ComponentProps<"h3">>);
    servicesSectionSwipersSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: ServicesSectionSwipersItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    servicesSectionDivsItemWrapper?: (item: ServicesSectionDivsItem, content: ReactNode) => ReactNode;
    servicesSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    servicesSectionDivsLinkVisible?: boolean;
    servicesSectionDivsLinkRenderer?: (item: ServicesSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServicesSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeSeventeenServicesSectionGenerated: FC<HomeSeventeenServicesSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Collaborative Healing Services",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "Personalized therapies and programs designed to address your unique wellness needs",
    sectionDiv2Link0LinkHref = "#",
    sectionDiv2Link0LinkVisible,
    sectionDiv2Link0LinkRenderer,
    sectionDiv2Link0LinkProps,
    sectionDiv2Link0Span0SpanText = "View All Services",
    linkLinkProps,
    sectionDiv1Swiper0SwiperProps,
    swiperSlideDiv0Div0Div0H30H3Props,
    swiperSlideDiv0Div0ImageWithBasePath0ImageProps,
    swiperSlideSwiperSlideProps,
    servicesSectionCircles,
    servicesSectionSwipers,
    servicesSectionCirclesItemWrapper,
    servicesSectionCirclesRenderer,
    servicesSectionSwipersItemWrapper,
    servicesSectionSwipersRenderer,
    servicesSectionSwipersImageVisible,
    servicesSectionSwipersImageRenderer,
    servicesSectionSwipersH3Visible,
    servicesSectionSwipersH3Renderer,
    servicesSectionSwipersImageProps,
    servicesSectionSwipersH3Props,
    servicesSectionSwipersSwiperSlideProps,
    servicesSectionDivsItemWrapper,
    servicesSectionDivsRenderer,
    servicesSectionDivsLinkVisible,
    servicesSectionDivsLinkRenderer,
    servicesSectionDivsLinkProps,
}) => {
    return (
        <section className="services-section-seventeen section">
            <div className="container">
                <div className="section-header section-header-seventeen wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title text-gradient" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    <p className="description">{sectionDiv0Div0P0PText}</p>
                </div>
            </div>
            <div className="service-slider-seventeen">
                <Swiper modules={[Autoplay]} loop={true} speed={1000} autoplay={{ delay: 3000, disableOnInteraction: true }} centeredSlides={true} slidesPerView={3} breakpoints={{
                    0: { slidesPerView: 1, centeredSlides: false },
                    576: { slidesPerView: 1, centeredSlides: false },
                    768: { slidesPerView: 1 },
                    992: { slidesPerView: 2 },
                    1200: { slidesPerView: 2 },
                    1400: { slidesPerView: 3 }
                }} {...(sectionDiv1Swiper0SwiperProps ?? {})}>
                    {renderCollectionNode(
                        servicesSectionSwipers,
                        (item: ServicesSectionSwipersItem) => (
                            <SwiperSlide {...(typeof servicesSectionSwipersSwiperSlideProps === "function" ? servicesSectionSwipersSwiperSlideProps(item) : (servicesSectionSwipersSwiperSlideProps ?? {}))} {...(typeof swiperSlideSwiperSlideProps === "function" ? swiperSlideSwiperSlideProps(item) : (swiperSlideSwiperSlideProps ?? {}))} key={item.key}>
                                <div className={item.className ?? "services-item-seventeen wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.div0ClassName ?? "services-img"}>
                                        {renderItemNode(servicesSectionSwipersImageVisible, servicesSectionSwipersImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "Wellness Therapies"} {...(typeof servicesSectionSwipersImageProps === "function" ? servicesSectionSwipersImageProps(item) : (servicesSectionSwipersImageProps ?? {}))} {...(typeof swiperSlideDiv0Div0ImageWithBasePath0ImageProps === "function" ? swiperSlideDiv0Div0ImageWithBasePath0ImageProps(item) : (swiperSlideDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        <div className={item.div0ClassName2 ?? "services-content"}>
                                            {renderItemNode(servicesSectionSwipersH3Visible, servicesSectionSwipersH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof servicesSectionSwipersH3Props === "function" ? servicesSectionSwipersH3Props(item) : (servicesSectionSwipersH3Props ?? {}))} {...(typeof swiperSlideDiv0Div0Div0H30H3Props === "function" ? swiperSlideDiv0Div0Div0H30H3Props(item) : (swiperSlideDiv0Div0Div0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                            ))}
                                            <p>{item.p0Text}</p>
                                            <div className="service-tags">
                                                {renderCollectionNode(
                                                    item.serviceTagsItems ?? [],
                                                    (item: ServicesSectionDivsItem) => (
                                                        renderItemNode(servicesSectionDivsLinkVisible, servicesSectionDivsLinkRenderer, item, (
                                                            <SmartLink href={item.href ?? "#"} {...(typeof servicesSectionDivsLinkProps === "function" ? servicesSectionDivsLinkProps(item) : (servicesSectionDivsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>{item.linkText}</SmartLink>
                                                        ))
                                                    ),
                                                    servicesSectionDivsItemWrapper,
                                                    servicesSectionDivsRenderer
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ),
                        servicesSectionSwipersItemWrapper,
                        servicesSectionSwipersRenderer
                    )}
                </Swiper>
            </div>
            <div className="view-top text-center">
                {renderNode(sectionDiv2Link0LinkVisible, sectionDiv2Link0LinkRenderer, (
                    <SmartLink href={sectionDiv2Link0LinkHref} className="theme-17-btn" {...(sectionDiv2Link0LinkProps ?? {})}>
                        <span className="text">{sectionDiv2Link0Span0SpanText}</span>
                        <span className="icon">
                            <i className="isax isax-arrow-right-1"></i>
                        </span>
                        <div className="container-stars">
                            <div className="stars"></div>
                        </div>
                        <div className="glow">
                            {renderCollectionNode(
                                servicesSectionCircles,
                                (item: ServicesSectionCirclesItem) => (
                                    <div className={item.className ?? "circle"} key={item.key}></div>
                                ),
                                servicesSectionCirclesItemWrapper,
                                servicesSectionCirclesRenderer
                            )}
                        </div>
                    </SmartLink>
                ))}
            </div>
        </section>
    );
};

export default HomeSeventeenServicesSectionGenerated;
